import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../../CommonUtils/CommonFormHeading'
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios';
import { config } from '../../../CommonUtils/CommonURLS';
import { viewImage } from '../../../CommonUtils/viewImage';
import Swal from 'sweetalert2';
import { failureAlert } from '../../../CommonUtils/SweetAlerts';
import moment from 'moment';
import { VscDiffAdded } from 'react-icons/vsc';
import { FaEye, FaHandPointRight, FaRegTrashAlt } from 'react-icons/fa';
import { AC_YEAR_OLD, ERROR_MSG } from '../../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GetStatusFlags } from '../../../Reducers/AffiliationCommonservice';
import { ImagePdfBucket } from '../../../CommonUtils/ImagesBase64';
import { BiSolidReport } from "react-icons/bi";
import { FcDocument } from "react-icons/fc";
import { GrDocumentPdf } from "react-icons/gr";

// export default function AfflilationOrderDetailsConfirmation({ onNext, setIsFirstTabSubmitted }) {
export default function AfflilationOrderDetailsConfirmation(props) {
    const { onNext, setIsFirstTabSubmitted, Type, instname, clgcode, status } = props
    console.log("AfflOrderDetailsConfirmed", status)

    let navigate = useNavigate();
    function navtoFfcaDocuments() {
        navigate("/Affiliation_Documents")
    }
    function navappCatgory() {
        navigate("/FfcaCollegeCourseDetails2021")
    }

    function navtofaculaty() {
        localStorage.setItem("collegeCode", CollegeCode);
        navigate("/FfcaEmployeeDetails_21")

    }


    // let Type = location?.state?.type;
    const userId = sessionStorage.getItem('user_id');
    const acYear = sessionStorage.getItem('ac_year');
    const CollegeCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const [AfflOrderConfirmData, setAfflOrderConfirmData] = useState();
    const afflorderConfirmvalidation = Yup.object({
        collName: Yup.string().required(ERROR_MSG).nullable(),
        collAddress: Yup.string().required(ERROR_MSG).nullable(),
        latEoaRefNo: Yup.string().required(ERROR_MSG).nullable(),
        latEopDate: Yup.string().required(ERROR_MSG).nullable(),
        isAfflAdditionalSections: Yup.string().required(ERROR_MSG).nullable(),
        afflAdditionalCoursesFlag: Yup.string().required(ERROR_MSG).nullable(),
        isAfflExistingCourses: Yup.string().required(ERROR_MSG).nullable(),
        permanentAfflStatusMeetingFlag: Yup.string().required(ERROR_MSG).nullable(),
        withdrawalExistingCoursesFlag: Yup.string().required(ERROR_MSG).nullable(),
        changeMediumFlag: Yup.string().required(ERROR_MSG).nullable(),
        isChangeColgAddr: Yup.string().required(ERROR_MSG).nullable(),
        finalRecomondationCdcDean: Yup.string().when('finalRecomondationCdcDeanflag', {
            is: (flag) => flag === 'OAMDC',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        // latEopOrderPdfhidden: Yup.string().when('latEopOrderPdf', {
        //     is: (latEopOrderPdfhidden) => !latEopOrderPdfhidden,
        //     then: Yup.string().required(ERROR_MSG).nullable(),
        //     otherwise: Yup.string().nullable(),
        // }),
        latEopOrderPdf: Yup.string().required(ERROR_MSG).nullable(),

        afflAdditionalCoursesFlagProceedingsPdf: Yup.string().when('afflAdditionalCoursesFlagProceedings', {
            is: (afflAdditionalCoursesFlagProceedings) => afflAdditionalCoursesFlagProceedings === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        // manualaffiliationPdfhidden: Yup.string().when('manualaffiliationPdf', {
        //     is: (manualaffiliationPdf) => !manualaffiliationPdf,
        //     then: Yup.string().required(ERROR_MSG).nullable(),
        //     otherwise: Yup.string().nullable(),
        // }),


        manualaffiliationPdf: Yup.string().required(ERROR_MSG).nullable(),

        isAfflAdditionalSectionsProceedings: Yup.string().when('isAfflAdditionalSections', {
            is: (val) => val === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired().nullable(),
        }),

        isAfflAdditionalSectionsProceedingsDate: Yup.string().when(['isAfflAdditionalSectionsProceedings', 'isAfflAdditionalSections'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),

        isAfflAdditionalSectionsProceedingsPdf: Yup.string().when('isAfflAdditionalSectionsProceedings', {
            is: (isAfflAdditionalSectionsProceedings) => isAfflAdditionalSectionsProceedings === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        isAfflAdditionalSectionsProceedingsRefNo: Yup.string().when(['isAfflAdditionalSectionsProceedings', 'isAfflAdditionalSections'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        afflAdditionalCoursesFlagProceedings: Yup.string().when('afflAdditionalCoursesFlag', {
            is: (val) => val === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        afflAdditionalCoursesFlagProceedingsDate: Yup.string().when(['afflAdditionalCoursesFlagProceedings', 'afflAdditionalCoursesFlag'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        afflAdditionalCoursesFlagProceedingsRefNo: Yup.string().when(['afflAdditionalCoursesFlagProceedings', 'afflAdditionalCoursesFlag'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        isAfflExistingCoursesProceedings: Yup.string().when('isAfflExistingCourses', {
            is: (val) => val === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired().nullable(),
        }),


        isAfflExistingCoursesProceedingsDate: Yup.string().when(
            ['isAfflExistingCoursesProceedings', 'isAfflExistingCourses'],
            {
                is: (val1, val2) => val1 === 'true' && val2 === 'true',
                then: Yup.string().required(ERROR_MSG).nullable(),
                otherwise: Yup.string().notRequired().nullable(),
            }
        ),




        isAfflExistingCoursesProceedingsRefNo: Yup.string().when(['isAfflExistingCoursesProceedings', 'isAfflExistingCourses'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired().nullable(),
        }),

        isAfflExistingCoursesProceedingsPdf: Yup.string().when('isAfflExistingCoursesProceedings', {
            is: (isAfflExistingCoursesProceedings) => isAfflExistingCoursesProceedings === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),



        permanentAfflStatusMeetingFlagProceedings: Yup.string().when('permanentAfflStatusMeetingFlag', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        permanentAfflStatusMeetingFlagProceedingsDate: Yup.string().when(['permanentAfflStatusMeetingFlagProceedings', 'permanentAfflStatusMeetingFlag'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        permanentAfflStatusMeetingFlagProceedingsRefNo: Yup.string().when(['permanentAfflStatusMeetingFlagProceedings', 'permanentAfflStatusMeetingFlag'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        permanentAfflStatusMeetingFlagProceedingsPdf: Yup.string().when('permanentAfflStatusMeetingFlagProceedings', {
            is: (permanentAfflStatusMeetingFlagProceedings) => permanentAfflStatusMeetingFlagProceedings === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        withdrawalExistingCoursesFlagProceedings: Yup.string().when('withdrawalExistingCoursesFlag', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        withdrawalExistingCoursesFlagProceedingsDate: Yup.string().when(['withdrawalExistingCoursesFlagProceedings', 'withdrawalExistingCoursesFlag'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        withdrawalExistingCoursesFlagProceedingsRefNo: Yup.string().when(['withdrawalExistingCoursesFlagProceedings', 'withdrawalExistingCoursesFlag'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        withdrawalExistingCoursesFlagProceedingsPdf: Yup.string().when('withdrawalExistingCoursesFlagProceedings', {
            is: (withdrawalExistingCoursesFlagProceedings) => withdrawalExistingCoursesFlagProceedings === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        changeMediumFlagProceedings: Yup.string().when('changeMediumFlag', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        changeMediumFlagProceedingsDate: Yup.string().when(['changeMediumFlagProceedings', 'changeMediumFlag'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        changeMediumFlagProceedingsRefNo: Yup.string().when(['changeMediumFlagProceedings', 'changeMediumFlag'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


        changeMediumFlagProceedingsPdf: Yup.string().when('changeMediumFlagProceedings', {
            is: (changeMediumFlagProceedings) => changeMediumFlagProceedings === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),



        isChangeColgAddrProceedings: Yup.string().when('isChangeColgAddr', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),

        isChangeColgAddrProceedingsDate: Yup.string().when(['isChangeColgAddrProceedings', 'isChangeColgAddr'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        isChangeColgAddrProceedingsRefNo: Yup.string().when(['isChangeColgAddrProceedings', 'isChangeColgAddr'], {
            is: (val1, val2) => val1 === 'true' && val2 === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),



        isChangeColgAddrProceedingsPdf: Yup.string().when('isChangeColgAddrProceedings', {
            is: (isChangeColgAddrProceedings) => isChangeColgAddrProceedings === 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),





        otherPreceedings: Yup.string().required(ERROR_MSG).nullable(),
        procedings: Yup.array().when('otherPreceedings', {
            is: (otherpcds) => otherpcds === 'true',
            then: Yup.array().of(
                Yup.object().shape({
                    refNo: Yup.string().required(ERROR_MSG).nullable(),
                    purposeOfIssuance: Yup.string().required(ERROR_MSG).nullable(),
                    otherProceedingsPdf: Yup.string().required(ERROR_MSG).nullable(),

                })
            ),
            otherwise: Yup.array().nullable(),
        }),
        isDeficienciesYesNo: Yup.string().required(ERROR_MSG).nullable(),
        deficiencies: Yup.array().when('isDeficienciesYesNo', {
            is: (otherpcds) => otherpcds === 'true',
            then: Yup.array().of(
                Yup.object().shape({
                    lastDate: Yup.string().required(ERROR_MSG).nullable(),
                    description: Yup.string().required(ERROR_MSG).nullable(),
                    campusType: Yup.string().required(ERROR_MSG).nullable(),

                })
            ),
            otherwise: Yup.array().nullable(),
        }),

        // noDefiCertif: Yup.boolean().when(
        //     ["isDeficienciesYesNo", "finalRecomondationCdcDeanflag"],
        //     {
        //         is: (isDeficienciesYesNo, finalRecomondationCdcDeanflag) =>
        //             (isDeficienciesYesNo === "false" || isDeficienciesYesNo === false) && finalRecomondationCdcDeanflag === "OAMDC" || finalRecomondationCdcDeanflag === "NONOAMDC",
        //         then: Yup.boolean().required(ERROR_MSG).nullable(),
        //         otherwise: Yup.boolean().nullable(),
        //     }
        // )


        noDefiCertif: Yup.boolean().when('isDeficienciesYesNo', {
            is: (isDeficienciesYesNo) => isDeficienciesYesNo === false,
            then: Yup.boolean().required(ERROR_MSG).nullable(),
            otherwise: Yup.boolean().nullable(),
        }),

    })
    const AfflOrderConfirmFormik = useFormik({
        initialValues: {
            ///  latEopOrderPdfhidden: "",
            latEopOrderPdf: "",

            manualaffiliationPdf: "",
            // manualaffiliationPdfhidden: "",

            isAfflAdditionalSections: "",
            isAfflAdditionalSectionsProceedings: "",
            isAfflAdditionalSectionsProceedingsDate: "",
            isAfflAdditionalSectionsProceedingsRefNo: "",

            isAfflAdditionalSectionsProceedingsPdf: "",

            afflAdditionalCoursesFlag: "",
            afflAdditionalCoursesFlagProceedings: "",
            afflAdditionalCoursesFlagProceedingsDate: "",
            afflAdditionalCoursesFlagProceedingsRefNo: "",

            afflAdditionalCoursesFlagProceedingsPdf: "",

            isAfflExistingCourses: "",
            isAfflExistingCoursesProceedings: "",
            isAfflExistingCoursesProceedingsDate: "",
            isAfflExistingCoursesProceedingsRefNo: "",

            isAfflExistingCoursesProceedingsPdf: "",

            permanentAfflStatusMeetingFlag: "",
            permanentAfflStatusMeetingFlagProceedings: "",
            permanentAfflStatusMeetingFlagProceedingsDate: "",
            permanentAfflStatusMeetingFlagProceedingsRefNo: "",

            permanentAfflStatusMeetingFlagProceedingsPdf: "",

            withdrawalExistingCoursesFlag: "",
            withdrawalExistingCoursesFlagProceedings: "",
            withdrawalExistingCoursesFlagProceedingsDate: "",
            withdrawalExistingCoursesFlagProceedingsRefNo: "",

            withdrawalExistingCoursesFlagProceedingsPdf: "",

            changeMediumFlag: "",
            changeMediumFlagProceedings: "",
            changeMediumFlagProceedingsDate: "",
            changeMediumFlagProceedingsRefNo: "",

            changeMediumFlagProceedingsPdf: "",

            isChangeColgAddr: "",
            isChangeColgAddrProceedings: "",
            isChangeColgAddrProceedingsDate: "",
            isChangeColgAddrProceedingsRefNo: "",

            isChangeColgAddrProceedingsPdf: "",

            collName: "",
            collAddress: "",
            collCode: CollegeCode,
            acYear: acYear,
            latEopDate: "",

            // noDefiCertif: false,
            noDefiCertif: '',

            latEoaRefNo: "",
            otherPreceedings: "",
            procedings: [{
                refNo: "",
                purposeOfIssuance: "",
                otherProceedingsPdf: "",
                slNo: "",
            }],
            isDeficienciesYesNo: "",
            deficiencies: [{
                lastDate: "",
                description: "",
                campusType: "",
                slNo: ""

            }],
            finalRecomondationCdcDean: "",
            finalRecomondationCdcDeanflag: Type

        },
        enableReinitialize: true,
        validationSchema: afflorderConfirmvalidation,
        onSubmit: (values) => {
            if (!values.otherPreceedings) {
                AfflOrderConfirmFormik.setFieldValue("procedings", [
                    {
                        refNo: "",
                        purposeOfIssuance: "",
                        otherProceedingsPdf: "",
                        slNo: "",
                    }
                ]);
            }

            if (!values.isDeficienciesYesNo) {
                AfflOrderConfirmFormik.setFieldValue("deficiencies", [
                    {
                        lastDate: "",
                        description: "",
                        campusType: "",
                        slNo: "",
                    }
                ]);
            }
            if (values?.noDefiCertif === false || values?.noDefiCertif === "false") {
                return Swal.fire({
                    title: "Accept all the terms and conditions",
                    icon: "warning",
                    backdrop: false,
                });
            }
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + "saveAfflOrderVerif";
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === "01") {
                            Swal.fire({
                                title: res?.data?.sdesc,
                                backdrop: false
                            }).then((res1) => {
                                if (res1?.isConfirmed === true) {
                                    GetAffflOrderDtlsConfirmation();
                                    setIsFirstTabSubmitted(true);
                                    onNext(Type);
                                }
                            });
                        } else {
                            failureAlert("Failed to Submit");
                        }
                    });
                }
            });
        }
    })

    function GetAffflOrderDtlsConfirmation() {
        let url = config.url.API_URL + `getAfflOrderVerif/` + CollegeCode + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data) {
                setAfflOrderConfirmData(res?.data)
                const AdditionalSectionProceedingDate = res?.data?.coursesFlags[0]?.is_affl_additional_sections_proceedings_date && moment(res?.data?.coursesFlags[0]?.is_affl_additional_sections_proceedings_date,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.coursesFlags[0]?.is_affl_additional_sections_proceedings_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const AdditionalCourseProceedingDate = res?.data?.coursesFlags[0]?.affl_additional_courses_flag_proceedings_date && moment(res?.data?.coursesFlags[0]?.affl_additional_courses_flag_proceedings_date,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.coursesFlags[0]?.affl_additional_courses_flag_proceedings_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const AdditionalExistingProceedingDate = res?.data?.coursesFlags[0]?.is_affl_existing_courses_proceedings_date && moment(res?.data?.coursesFlags[0]?.is_affl_existing_courses_proceedings_date,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.coursesFlags[0]?.is_affl_existing_courses_proceedings_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const AdditionalPermanentProceedingDate = res?.data?.coursesFlags[0]?.permanent_affl_status_meeting20_21_flag_proceedings_date && moment(res?.data?.coursesFlags[0]?.permanent_affl_status_meeting20_21_flag_proceedings_date,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.coursesFlags[0]?.permanent_affl_status_meeting20_21_flag_proceedings_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const AdditionalWithdrwalExistingProceedingDate = res?.data?.coursesFlags[0]?.withdrawal_existing_courses_flag_proceedings_date && moment(res?.data?.coursesFlags[0]?.withdrawal_existing_courses_flag_proceedings_date,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.coursesFlags[0]?.withdrawal_existing_courses_flag_proceedings_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const changeMediumDate = res?.data?.coursesFlags[0]?.change_medium_flag_proceedings_date && moment(res?.data?.coursesFlags[0]?.change_medium_flag_proceedings_date,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.coursesFlags[0]?.change_medium_flag_proceedings_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const changeAdressDate = res?.data?.coursesFlags[0]?.is_change_colg_addr_proceedings_date && moment(res?.data?.coursesFlags[0]?.is_change_colg_addr_proceedings_date,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.coursesFlags[0]?.is_change_colg_addr_proceedings_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                const LATEopDate = res?.data?.totalData[0]?.lat_eop_date && moment(res?.data?.totalData[0]?.lat_eop_date,
                    'DD-MM-YYYY', true).isValid() ? moment(res?.data?.totalData[0]?.lat_eop_date, 'DD-MM-YYYY').format('YYYY-MM-DD') : null;
                AfflOrderConfirmFormik?.setFieldValue("latEopOrderPdf", res?.data?.totalData[0]?.lat_eop_order_pdf);
                AfflOrderConfirmFormik?.setFieldValue("collName", res?.data?.totalData[0]?.inst_name);
                AfflOrderConfirmFormik?.setFieldValue("manualaffiliationPdf", res?.data?.totalData[0]?.affiliation_copy_pdf);

                AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSections", res?.data?.coursesFlags[0]?.is_affl_additional_sections?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedings", res?.data?.coursesFlags[0]?.is_affl_additional_sections_proceedings?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsDate", AdditionalSectionProceedingDate ?? '');
                AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsRefNo", res?.data?.coursesFlags[0]?.is_affl_additional_sections_proceedings_ref_no);
                AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsPdf", res?.data?.coursesFlags[0]?.is_affl_additional_sections_proceedings_pdf || '');

                AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlag", res?.data?.coursesFlags[0]?.affl_additional_courses_flag?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedings", res?.data?.coursesFlags[0]?.affl_additional_courses_flag_proceedings?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsDate", AdditionalCourseProceedingDate ?? '');
                AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsRefNo", res?.data?.coursesFlags[0]?.affl_additional_courses_flag_proceedings_ref_no);
                AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsPdf", res?.data?.coursesFlags[0]?.affl_additional_courses_flag_proceedings_pdf || '');


                AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCourses", res?.data?.coursesFlags[0]?.is_affl_existing_courses?.toString() ?? '');

                AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedings", res?.data?.coursesFlags[0]?.is_affl_existing_courses_proceedings?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsDate", AdditionalExistingProceedingDate ?? '');
                AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsRefNo", res?.data?.coursesFlags[0]?.is_affl_existing_courses_proceedings_ref_no);
                AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsPdf", res?.data?.coursesFlags[0]?.is_affl_existing_courses_proceedings_pdf || '');

                AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlag", res?.data?.coursesFlags[0]?.permanent_affl_status_meeting20_21_flag?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedings", res?.data?.coursesFlags[0]?.permanent_affl_status_meeting20_21_flag_proceedings?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsDate", AdditionalPermanentProceedingDate ?? '');
                AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsRefNo", res?.data?.coursesFlags[0]?.permanent_affl_status_meeting20_21_flag_proceedings_ref_no);
                AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsPdf", res?.data?.coursesFlags[0]?.permanent_affl_status_meeting20_21_flag_proceedings_pdf || '');

                AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlag", res?.data?.coursesFlags[0]?.withdrawal_existing_courses_flag?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedings", res?.data?.coursesFlags[0]?.withdrawal_existing_courses_flag_proceedings?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsDate", AdditionalWithdrwalExistingProceedingDate ?? '');
                AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsRefNo", res?.data?.coursesFlags[0]?.withdrawal_existing_courses_flag_proceedings_ref_no);
                AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsPdf", res?.data?.coursesFlags[0]?.withdrawal_existing_courses_flag_proceedings_pdf || '');

                AfflOrderConfirmFormik?.setFieldValue("changeMediumFlag", res?.data?.coursesFlags[0]?.change_medium_flag?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedings", res?.data?.coursesFlags[0]?.change_medium_flag_proceedings?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsDate", changeMediumDate ?? '');
                AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsRefNo", res?.data?.coursesFlags[0]?.change_medium_flag_proceedings_ref_no);
                AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsPdf", res?.data?.coursesFlags[0]?.change_medium_flag_proceedings_pdf || '');

                AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddr", res?.data?.coursesFlags[0]?.is_change_colg_addr?.toString());
                AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedings", res?.data?.coursesFlags[0]?.is_change_colg_addr_proceedings?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsDate", changeAdressDate ?? '');
                AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsRefNo", res?.data?.coursesFlags[0]?.is_change_colg_addr_proceedings_ref_no);
                AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsPdf", res?.data?.coursesFlags[0]?.is_change_colg_addr_proceedings_pdf || '');

                AfflOrderConfirmFormik?.setFieldValue("collAddress", res?.data?.totalData[0]?.inst_address);
                AfflOrderConfirmFormik?.setFieldValue("latEoaRefNo", res?.data?.totalData[0]?.lat_eoa_ref_no)
                AfflOrderConfirmFormik?.setFieldValue("latEopDate", LATEopDate ?? '');
                AfflOrderConfirmFormik?.setFieldValue("finalRecomondationCdcDean", res?.data?.totalData[0]?.final_recomondation_cdc_dean);
                AfflOrderConfirmFormik?.setFieldValue("noDefiCertif", res?.data?.totalData[0]?.no_defi_certif?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("otherPreceedings", res?.data?.totalData[0]?.other_preceedings?.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("isDeficienciesYesNo", res?.data?.totalData[0]?.is_deficiencies_yes_no.toString() ?? '');
                AfflOrderConfirmFormik?.setFieldValue("procedingsFlag", res?.data?.proceedings?.length);
                AfflOrderConfirmFormik?.setFieldValue("deficiencyFlag", res?.data?.deficiencies?.length);

                res?.data?.proceedings?.forEach((data, i) => { AfflOrderConfirmFormik?.setFieldValue(`procedings[${i}].slNo`, data?.sl_no); })
                res?.data?.deficiencies?.forEach((data, i) => { AfflOrderConfirmFormik?.setFieldValue(`deficiencies[${i}].slNo`, data?.sl_no); })
                res?.data?.proceedings?.forEach((pro, i) => {
                    AfflOrderConfirmFormik?.setFieldValue(`procedings[${i}].refNo`, pro?.ref_no);
                    AfflOrderConfirmFormik?.setFieldValue(`procedings[${i}].purposeOfIssuance`, pro?.purpose_of_issuance);
                    AfflOrderConfirmFormik?.setFieldValue(`procedings[${i}].otherProceedingsPdf`, pro?.other_proceedings_pdf);
                });
                res?.data?.deficiencies?.forEach((def, i) => {
                    AfflOrderConfirmFormik?.setFieldValue(`deficiencies[${i}].lastDate`, def?.last_date);
                    AfflOrderConfirmFormik?.setFieldValue(`deficiencies[${i}].description`, def?.description);
                    AfflOrderConfirmFormik?.setFieldValue(`deficiencies[${i}].campusType`, def?.campus_type?.toString() ?? '');
                });


            }
            else {
                setAfflOrderConfirmData({});
            }
        })
    }
    function GetFfcaSubmissionPdf() {
        const url = `${config.url.API_URL}getFfcaPdf/${CollegeCode}/${acYear}`;
        CommonAxiosPost(url).then((res) => {
            if (res?.data?.Status) {
                viewImage(res.data.path);
            } else {
                console.log("No Data Found");
            }
        });
    }

    function GetCollgePdf() {
        let payload = {}
        let url = config.url.API_URL + `getAffiliationPdf/` + CollegeCode + "/" + acYear;
        CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }
    useEffect(() => {
        GetAffflOrderDtlsConfirmation();
        GetStatusFlags(acYear, CollegeCode)
    }, [])
    const getColspanValue = (flag, flagProceedings) => {
        if (flag === "true" && (flagProceedings === "false" || flagProceedings === "")) {
            return <td colSpan={3}></td>;
        }
        return <></>;
    };

    const permanentAfflStatusMeeting20_21Flagcolspanvalues = getColspanValue(
        AfflOrderConfirmFormik?.values?.permanentAfflStatusMeetingFlag,
        AfflOrderConfirmFormik?.values?.permanentAfflStatusMeetingFlagProceedings
    );

    const afflAdditionalCoursesFlagcolspanvalue = getColspanValue(
        AfflOrderConfirmFormik?.values?.afflAdditionalCoursesFlag,
        AfflOrderConfirmFormik?.values?.afflAdditionalCoursesFlagProceedings
    );

    const isAfflExistingCoursescolspanvalue = getColspanValue(
        AfflOrderConfirmFormik?.values?.isAfflExistingCourses,
        AfflOrderConfirmFormik?.values?.isAfflExistingCoursesProceedings
    );

    const isAfflAdditionalSectionscolspanvalue = getColspanValue(
        AfflOrderConfirmFormik?.values?.isAfflAdditionalSections,
        AfflOrderConfirmFormik?.values?.isAfflAdditionalSectionsProceedings
    );

    const withdrawalExistingCoursesFlagcolspanvalue = getColspanValue(
        AfflOrderConfirmFormik?.values?.withdrawalExistingCoursesFlag,
        AfflOrderConfirmFormik?.values?.withdrawalExistingCoursesFlagProceedings
    );

    const changeMediumFlagcolspanvalue = getColspanValue(
        AfflOrderConfirmFormik?.values?.changeMediumFlag,
        AfflOrderConfirmFormik?.values?.changeMediumFlagProceedings
    );

    const isChangeColgAddrcolspanvalue = getColspanValue(
        AfflOrderConfirmFormik?.values?.isChangeColgAddr,
        AfflOrderConfirmFormik?.values?.isChangeColgAddrProceedings
    );
    const buttonStyle = {
        width: '100%',
        padding: '10px 16px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        fontSize: '14px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };
    function BackNav() {
        navigate(-1)
    }

    return (
        <>
            <CommonFormHeading heading="AFFILIATION ORDER - DETAILS CONFIRMATION - DATA CAPTURING" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={AfflOrderConfirmFormik}>
                    <Form onChange={AfflOrderConfirmFormik.handleChange} onSubmit={AfflOrderConfirmFormik.handleSubmit} className="affl-form" >

                        <bie.Row >

                            <bie.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>
                                <b style={{ color: "brown" }}> {instname}-{clgcode}</b> <br /><br />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                <button type="button" onClick={BackNav} className="btn btn-primary btn-sm float-end">Back</button>
                            </bie.Col>
                        </bie.Row>

                        <bie.Row >

                            <bie.Col xs={12} sm={6} md={4} lg={3}>
                                <button type="button" onClick={GetCollgePdf} style={{ ...buttonStyle, backgroundColor: '#0056b3' }}
                                    onMouseEnter={e => e.target.style.backgroundColor = '#9e13a1'}
                                    onMouseLeave={e => e.target.style.backgroundColor = '#007bff'}>Application Submitted by College <GrDocumentPdf size={25} /></button>
                            </bie.Col>
                            <bie.Col xs={12} sm={6} md={4} lg={2}>
                                <button
                                    style={{ ...buttonStyle, backgroundColor: '#0056b3' }}
                                    onMouseEnter={e => e.target.style.backgroundColor = '#9e13a1'}
                                    onMouseLeave={e => e.target.style.backgroundColor = '#007bff'}
                                    type='button' onClick={GetFfcaSubmissionPdf} >FFCA Report <BiSolidReport size={25} /> </button>
                            </bie.Col>
                            <bie.Col xs={12} sm={6} md={4} lg={2}>
                                <button
                                    style={{ ...buttonStyle, backgroundColor: '#0056b3' }}
                                    onMouseEnter={e => e.target.style.backgroundColor = '#9e13a1'}
                                    onMouseLeave={e => e.target.style.backgroundColor = '#007bff'}
                                    type="button" onClick={navtofaculaty}>Faculty Report <BiSolidReport size={25} /></button>
                            </bie.Col>

                            <bie.Col xs={12} sm={6} md={4} lg={2}>
                                <button
                                    style={{ ...buttonStyle, backgroundColor: '#0056b3' }}
                                    onMouseEnter={e => e.target.style.backgroundColor = '#9e13a1'}
                                    onMouseLeave={e => e.target.style.backgroundColor = '#007bff'}
                                    type="button" onClick={navtoFfcaDocuments} >Affiliation Documents<FcDocument size={25} /></button>
                            </bie.Col>
                            <bie.Col xs={12} sm={6} md={4} lg={2}>
                                <button
                                    style={{ ...buttonStyle, backgroundColor: '#0056b3' }}
                                    onMouseEnter={e => e.target.style.backgroundColor = '#9e13a1'}
                                    onMouseLeave={e => e.target.style.backgroundColor = '#007bff'} type="button" onClick={navappCatgory}>Application Category <GrDocumentPdf size={25} /></button>
                            </bie.Col>



                        </bie.Row>



                        <bie.Row className='pt-3'>
                            <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <bie.Alert variant="danger" className='affl-alert' >
                                    <p className="mb-0">Note :1. As This name will be appearing on the Affiliation Order and Public domain, College Name shall be in accordance with the Permission proceedings of the Competent Authority.<br />
                                        2. This address which CDC Dean confirms hereShall be displayed in the Affiliation Order and in Public domain for the Convenience of the Students<br />
                                        3. Any change in address of the college shall be permitted only upon the Permission Proceedings from Competent Authority.</p>
                                </bie.Alert>
                            </bie.Col>
                        </bie.Row>

                        <bie.Row className='pt-4'>

                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">COLLEGE - GEO LOCATION - {acYear}</h1></div>
                            <div className='table-responsive'>
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>
                                                Lat Long Coordinates:
                                            </th>
                                            <th>
                                                Lat Long Description:
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {AfflOrderConfirmData?.totalData[0]?.lat_long || "-"}
                                            </td>
                                            <td>
                                                {AfflOrderConfirmData?.totalData[0]?.lat_long_name || "-"}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">College and Society Details
                                </h1></div>
                            <bie.Row className='px-3 my-3'>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                    <label className='mb-1'>Name of the Educational Society:</label>
                                    <Field type='text' name="officerName"
                                        className="form-control mb-2" disabled value={AfflOrderConfirmData?.totalData[0]?.society_name}></Field>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                    <label className='mb-1'>Nature of the college:	</label>
                                    <Field type='text' name="officerName"
                                        className="form-control mb-2" disabled value={AfflOrderConfirmData?.totalData[0]?.coll_nature_name}></Field>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                    <label className='mb-1'>Name of the College:</label>
                                    <Field type="text" name="collName" className="form-control" maxLength="200" />
                                    <ErrorMessage name="collName" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                    <label className='mb-1'><b style={{ color: "red" }}>  *</b>Address of the college:</label>
                                    <Field as="textarea" name="collAddress" className="form-control" maxLength="450" />
                                    <ErrorMessage name="collAddress" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                    <label className='mb-1'>Address Proof of the college:</label>
                                    <div className='form-control' style={{ backgroundColor: '#e9ecef' }}>
                                        {AfflOrderConfirmData?.totalData[0]?.inst_addr_proof_pdf && (
                                            <button type='button' className="btn btn-primary" onClick={() => { viewImage(AfflOrderConfirmData?.totalData[0]?.inst_addr_proof_pdf); }}
                                                style={{ cursor: 'pointer', }}><FaEye size={20} /></button>
                                        )}
                                    </div>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                    <label className='mb-1'>Year of Establishment:	</label>
                                    <Field type='text' name="officerName"
                                        className="form-control mb-2" disabled value={AfflOrderConfirmData?.totalData[0]?.inst_estd}></Field>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                    <label className='mb-1'>Type of Accommodation of the college:</label>
                                    <Field type='text' name="officerName"
                                        className="form-control mb-2" disabled value={AfflOrderConfirmData?.totalData[0]?.build_own_lease}></Field>
                                </bie.Col>
                            </bie.Row>

                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">Approval Details - Competent Authority (AICTE/CHE/BCI/PCI/NCTE)
                                </h1></div>

                            <div className="px-2 my-3">
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                        <label className='mb-1'><b style={{ color: 'red' }}>* </b>
                                            Latest EOA/EOP (AICTE/CHE/BCI/PCI) - PDF
                                            (If CHE - EOP issued in 2022 for Leased Buildings)
                                        </label>
                                        <div className='d-flex align-items-center'>
                                            <input type="file" name="latEopOrderPdf" className="form-control" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `latEopOrderPdf`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/LatestInspectionReport/";
                                                    ImagePdfBucket(e, AfflOrderConfirmFormik, path, "latEopOrderPdf", filename, "pdf");
                                                }} />
                                            {AfflOrderConfirmData?.totalData[0]?.lat_eop_order_pdf && (
                                                <button type="button" onClick={() => { viewImage(AfflOrderConfirmData?.totalData[0]?.lat_eop_order_pdf); }} className="btn btn-primary"
                                                    style={{ cursor: 'pointer' }}><FaEye size={20} /></button>
                                            )}
                                        </div>
                                        <ErrorMessage name="latEopOrderPdf" component="div" className="text-error" />
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                        <label className='mb-1'><b style={{ color: 'red' }}>* </b>
                                            Reference No. of Proceedings:
                                        </label>
                                        <Field type="text" className="form-control mb-2 mt-3" name="latEoaRefNo" maxLength="80" />
                                        <ErrorMessage name="latEoaRefNo" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                        <label className='mb-1'><b style={{ color: 'red' }}>* </b>
                                            Date of Issuance:
                                        </label>
                                        <Field type="date" className="form-control mb-2 mt-3" name="latEopDate"
                                            max={new Date().toISOString().split('T')[0]} />
                                        <ErrorMessage name="latEopDate" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3}>
                                        <label className='mb-1'><b style={{ color: 'red' }}>* </b>
                                            Affiliation Order {AC_YEAR_OLD}:
                                        </label>
                                        <div className='d-flex align-items-center'>
                                            <input type="file" name="manualaffiliationPdf" className="form-control mb-2 mt-3" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `manualaffiliationPdf`;
                                                    let path = "/Uploads/AffiliationOrder_2023/CDC/";
                                                    ImagePdfBucket(e, AfflOrderConfirmFormik, path, `manualaffiliationPdf`, filename, "pdf");
                                                }} />
                                            <ErrorMessage name="manualaffiliationPdf" component="div" className="text-error" />
                                            {AfflOrderConfirmData?.totalData[0]?.affiliation_copy_pdf && (
                                                <button type="button" className="btn btn-primary"
                                                    onClick={() => { viewImage(AfflOrderConfirmData?.totalData[0]?.affiliation_copy_pdf); }} style={{ cursor: 'pointer' }}>
                                                    <FaEye size={20} />
                                                </button>
                                            )}
                                        </div>
                                    </bie.Col>
                                </bie.Row>
                            </div>
                            {AfflOrderConfirmData?.deficienciesOld.length > 0 ? (<>

                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0">Report of Compliance of {AC_YEAR_OLD}:</h1></div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Deficiency</th>
                                                <th>Status of Deficiency</th>
                                                <th>Remarks of Deficiency</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {AfflOrderConfirmData?.deficienciesOld && AfflOrderConfirmData?.deficienciesOld?.map((afflorderdata, index) => (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td className='text-left'>{afflorderdata?.description}</td>
                                                        <td className='text-left'>{afflorderdata?.ffca_status_of_deficiency}</td>
                                                        <td className='text-left'>{afflorderdata?.ffca_deficiency_remarks}</td>

                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>) : (<></>)}

                            {AfflOrderConfirmData?.feeDues.length > 0 ? (<>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0">Fee Dues to University {acYear}:</h1></div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>

                                            <tr>
                                                <th>S.No</th>
                                                <th>Academic Year</th>
                                                <th>Amount of Affiliation Fees pending
                                                    by the college to the University</th>
                                                <th> Amount of UCS Fee pending by the
                                                    college till the last academic year </th>
                                                <th>Total Fee Pending </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {AfflOrderConfirmData?.feeDues && AfflOrderConfirmData?.feeDues?.map((afflorderdata, index) => (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{afflorderdata?.ac_yearr}</td>
                                                        <td>{afflorderdata?.fees_pending_by_college}</td>
                                                        <td>{afflorderdata?.ucs_fee_pending}</td>
                                                        <td>{afflorderdata?.total_pending_fee_amount}</td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>) : (<></>)}
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">College Application Category - Competent Authority Permissions:</h1></div>


                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>Category of Application	</th>
                                            <th>Has college submitted Affiliation Application Under this category</th>
                                            <th>Has the college submitted Permission proceedingsof Competent Authority (AICTE/CHE/PCI/BCI/NCTE)</th>
                                            <th> Date of such Permission proceedings </th>
                                            <th>Reference Number of such Permission proceedings </th>
                                            <th>Upload (PDF)</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>

                                            <td className='text-left'> 1.Additional Section for Existing courses:	</td>
                                            <td style={{ width: "1%" }}>
                                                <Field as="select" className="form-control" name="isAfflAdditionalSections"
                                                    onChange={e => {

                                                        AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedings", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsDate", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsRefNo", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsPdf", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsPdfhidden", '');

                                                    }}>
                                                    <option value=''>---selct---</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Field>
                                                <ErrorMessage name="isAfflAdditionalSections" component="div" className="text-error" />

                                            </td>
                                            {AfflOrderConfirmFormik?.values?.isAfflAdditionalSections === "true" ? (<>
                                                <td style={{ width: "1%" }}>
                                                    <Field as="select" className="form-control" name="isAfflAdditionalSectionsProceedings"
                                                        onChange={e => {
                                                            AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsDate", '');
                                                            AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsRefNo", '');
                                                            AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsPdfhidden", '');
                                                            AfflOrderConfirmFormik?.setFieldValue("isAfflAdditionalSectionsProceedingsPdf", '');

                                                        }}>
                                                        <option value=''>---selct---</option>
                                                        <option value="true">Yes</option>
                                                        <option value="false">No</option>
                                                    </Field>
                                                    <ErrorMessage name="isAfflAdditionalSectionsProceedings" component="div" className="text-error" />

                                                </td>
                                            </>) : (<td colSpan={4}> </td>)}
                                            {AfflOrderConfirmFormik?.values?.isAfflAdditionalSections === "true" && AfflOrderConfirmFormik?.values?.isAfflAdditionalSectionsProceedings === "true" ? (<>
                                                <td>  <Field type="date" className="form-control" name="isAfflAdditionalSectionsProceedingsDate" onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="isAfflAdditionalSectionsProceedingsDate" component="div" className="text-error" />

                                                </td>
                                                <td><Field type="text" className="form-control" name="isAfflAdditionalSectionsProceedingsRefNo" maxLength="150" />
                                                    <ErrorMessage name="isAfflAdditionalSectionsProceedingsRefNo" component="div" className="text-error" /> </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>

                                                        <input type="file" name="isAfflAdditionalSectionsProceedingsPdf" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = `isAfflAdditionalSectionsProceedingsPdf`;
                                                                let path = "/Uploads/AffiliationPDFs/CDC/2023/";
                                                                ImagePdfBucket(e, AfflOrderConfirmFormik, path, `isAfflAdditionalSectionsProceedingsPdf`, filename, "pdf");
                                                            }} />
                                                        <ErrorMessage name="isAfflAdditionalSectionsProceedingsPdf" component="div" className="text-error" />


                                                        {AfflOrderConfirmFormik?.values?.isAfflAdditionalSectionsProceedingsPdf &&
                                                            (
                                                                <button type='button' className="btn btn-primary" onClick={() => { viewImage(AfflOrderConfirmFormik?.values?.isAfflAdditionalSectionsProceedingsPdf) }}>
                                                                    <FaEye size={20} />
                                                                </button>
                                                            )
                                                        }
                                                    </div>

                                                </td>


                                            </>) : (isAfflAdditionalSectionscolspanvalue)}
                                        </tr>
                                        <tr>

                                            <td className='text-left'> 2.Affiliation for Additional Courses:	 </td>
                                            <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="afflAdditionalCoursesFlag"
                                                onChange={e => {
                                                    AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedings", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsDate", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsRefNo", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsPdf", '');
                                                }}>

                                                <option value=''>---selct---</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Field>
                                                <ErrorMessage name="afflAdditionalCoursesFlag" component="div" className="text-error" />

                                            </td>
                                            {AfflOrderConfirmFormik?.values?.afflAdditionalCoursesFlag === "true" ? (<>
                                                <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="afflAdditionalCoursesFlagProceedings"
                                                    onChange={e => {
                                                        AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsDate", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsRefNo", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("afflAdditionalCoursesFlagProceedingsPdf", '');
                                                    }}>
                                                    <option value=''>---selct---</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Field>
                                                    <ErrorMessage name="afflAdditionalCoursesFlagProceedings" component="div" className="text-error" /></td>
                                            </>) : (<td colSpan={4}></td>)}
                                            {AfflOrderConfirmFormik?.values?.afflAdditionalCoursesFlag === "true" && AfflOrderConfirmFormik?.values?.afflAdditionalCoursesFlagProceedings == "true" ? (<>

                                                <td>  <Field type="date" className="form-control" name="afflAdditionalCoursesFlagProceedingsDate" onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="afflAdditionalCoursesFlagProceedingsDate" component="div" className="text-error" />

                                                </td>
                                                <td><Field type="text" className="form-control" name="afflAdditionalCoursesFlagProceedingsRefNo" maxLength="150" />
                                                    <ErrorMessage name="afflAdditionalCoursesFlagProceedingsRefNo" component="div" className="text-error" /> </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>

                                                        <input type="file" name="afflAdditionalCoursesFlagProceedingsPdf" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = `afflAdditionalCoursesFlagProceedingsPdf`;
                                                                let path = "/Uploads/AffiliationPDFs/CDC/2023/";
                                                                ImagePdfBucket(e, AfflOrderConfirmFormik, path, `afflAdditionalCoursesFlagProceedingsPdf`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name="afflAdditionalCoursesFlagProceedingsPdf" component="div" className="text-error" />

                                                        {AfflOrderConfirmFormik?.values?.afflAdditionalCoursesFlagProceedingsPdf &&
                                                            (
                                                                <button type='button' className="btn btn-primary" onClick={() => { viewImage(AfflOrderConfirmFormik?.values?.afflAdditionalCoursesFlagProceedingsPdf) }}>
                                                                    <FaEye size={20} />
                                                                </button>
                                                            )
                                                        }
                                                    </div>


                                                </td>


                                            </>) : (afflAdditionalCoursesFlagcolspanvalue)}
                                        </tr>
                                        <tr>

                                            <td className='text-left'>3. Permanent Affiliation for Existing courses:	</td>

                                            <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="isAfflExistingCourses"
                                                onChange={e => {
                                                    AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedings", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsDate", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsRefNo", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsPdf", '');
                                                }}>
                                                <option value=''>---selct---</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Field>
                                                <ErrorMessage name="isAfflExistingCourses" component="div" className="text-error" />

                                            </td>
                                            {AfflOrderConfirmFormik?.values?.isAfflExistingCourses === "true" ? (<>
                                                <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="isAfflExistingCoursesProceedings"
                                                    onChange={e => {
                                                        AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsDate", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsRefNo", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("isAfflExistingCoursesProceedingsPdf", '');
                                                    }}>

                                                    <option value=''>---selct---</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Field>
                                                    <ErrorMessage name="isAfflExistingCoursesProceedings" component="div" className="text-error" /></td>
                                            </>) : (<td colSpan={4}></td>)}
                                            {AfflOrderConfirmFormik?.values?.isAfflExistingCourses === "true" && AfflOrderConfirmFormik?.values?.isAfflExistingCoursesProceedings === "true" ? (<>

                                                <td>  <Field type="date" className="form-control" name="isAfflExistingCoursesProceedingsDate"
                                                    onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="isAfflExistingCoursesProceedingsDate" component="div" className="text-error" />

                                                </td>
                                                <td><Field type="text" className="form-control" name="isAfflExistingCoursesProceedingsRefNo" maxLength="150" />
                                                    <ErrorMessage name="isAfflExistingCoursesProceedingsRefNo" component="div" className="text-error" /> </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>


                                                        <input type="file" name="isAfflExistingCoursesProceedingsPdf" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = `isAfflExistingCoursesProceedingsPdf`;
                                                                let path = "/Uploads/AffiliationPDFs/CDC/2023/";
                                                                ImagePdfBucket(e, AfflOrderConfirmFormik, path, `isAfflExistingCoursesProceedingsPdf`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name="isAfflExistingCoursesProceedingsPdf" component="div" className="text-error" />


                                                        {AfflOrderConfirmFormik?.values?.isAfflExistingCoursesProceedingsPdf &&
                                                            (
                                                                <button type='button' className="btn btn-primary" onClick={() => { viewImage(AfflOrderConfirmFormik?.values?.isAfflExistingCoursesProceedingsPdf) }}>
                                                                    <FaEye size={20} />
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </td>
                                            </>) : (isAfflExistingCoursescolspanvalue)}
                                        </tr>
                                        <tr>

                                            <td className='text-left'>4. Withdrawal of Existing courses / Combinations / Section(s):	 </td>
                                            <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="withdrawalExistingCoursesFlag"
                                                onChange={e => {
                                                    AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedings", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsDate", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsRefNo", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsPdf", '');
                                                }}>
                                                <option value=''>---selct---</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Field>
                                                <ErrorMessage name="withdrawalExistingCoursesFlag" component="div" className="text-error" />

                                            </td>
                                            {AfflOrderConfirmFormik?.values?.withdrawalExistingCoursesFlag === "true" ? (<>
                                                <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="withdrawalExistingCoursesFlagProceedings"
                                                    onChange={e => {
                                                        AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsDate", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsRefNo", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("withdrawalExistingCoursesFlagProceedingsPdf", '');
                                                    }}>

                                                    <option value=''>---selct---</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Field>
                                                    <ErrorMessage name="withdrawalExistingCoursesFlagProceedings" component="div" className="text-error" />

                                                </td>
                                            </>) : (<td colSpan={4}></td>)}
                                            {AfflOrderConfirmFormik?.values?.withdrawalExistingCoursesFlag === "true" && AfflOrderConfirmFormik?.values?.withdrawalExistingCoursesFlagProceedings === "true" ? (<>

                                                <td>  <Field type="date" className="form-control" name="withdrawalExistingCoursesFlagProceedingsDate" onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="withdrawalExistingCoursesFlagProceedingsDate" component="div" className="text-error" />

                                                </td>
                                                <td><Field type="text" className="form-control" name="withdrawalExistingCoursesFlagProceedingsRefNo" maxLength="150" />
                                                    <ErrorMessage name="withdrawalExistingCoursesFlagProceedingsRefNo" component="div" className="text-error" /> </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>


                                                        <input type="file" name="withdrawalExistingCoursesFlagProceedingsPdf" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = `withdrawalExistingCoursesFlagProceedingsPdf`;
                                                                let path = "/Uploads/AffiliationPDFs/CDC/2023/";
                                                                ImagePdfBucket(e, AfflOrderConfirmFormik, path, `withdrawalExistingCoursesFlagProceedingsPdf`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name="withdrawalExistingCoursesFlagProceedingsPdf" component="div" className="text-error" />

                                                        {AfflOrderConfirmFormik?.values?.withdrawalExistingCoursesFlagProceedingsPdf &&
                                                            (
                                                                <button type='button' className="btn btn-primary" onClick={() => { viewImage(AfflOrderConfirmFormik?.values?.withdrawalExistingCoursesFlagProceedingsPdf) }}>
                                                                    <FaEye size={20} />
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </td>
                                            </>) : (withdrawalExistingCoursesFlagcolspanvalue)}

                                        </tr>
                                        <tr>

                                            <td className='text-left'>5.Change of Medium for any Existing courses / Combinations:
                                            </td>
                                            <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="changeMediumFlag"
                                                onChange={e => {
                                                    AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsDate", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedings", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsRefNo", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsPdf", '');
                                                }}>
                                                <option value=''>---selct---</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Field>
                                                <ErrorMessage name="changeMediumFlag" component="div" className="text-error" />

                                            </td>
                                            {AfflOrderConfirmFormik?.values?.changeMediumFlag == "true" ? (<>
                                                <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="changeMediumFlagProceedings"
                                                    onChange={e => {
                                                        AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsDate", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsRefNo", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("changeMediumFlagProceedingsPdf", '');
                                                    }}>
                                                    <option value=''>---selct---</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Field>
                                                    <ErrorMessage name="changeMediumFlagProceedings" component="div" className="text-error" />

                                                </td>
                                            </>) : (<td colSpan={4}></td>)}
                                            {AfflOrderConfirmFormik?.values?.changeMediumFlag == "true" && AfflOrderConfirmFormik?.values?.changeMediumFlagProceedings == "true" ? (<>

                                                <td>  <Field type="date" className="form-control" name="changeMediumFlagProceedingsDate" onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="changeMediumFlagProceedingsDate" component="div" className="text-error" />

                                                </td>
                                                <td><Field type="text" className="form-control" name="changeMediumFlagProceedingsRefNo" maxLength="150" />
                                                    <ErrorMessage name="changeMediumFlagProceedingsRefNo" component="div" className="text-error" /> </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <input type="file" name="changeMediumFlagProceedingsPdf" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = `changeMediumFlagProceedingsPdf`;
                                                                let path = "/Uploads/AffiliationPDFs/CDC/2023/";
                                                                ImagePdfBucket(e, AfflOrderConfirmFormik, path, `changeMediumFlagProceedingsPdf`, filename, "pdf");
                                                            }}
                                                        />

                                                        <ErrorMessage name="changeMediumFlagProceedingsPdf" component="div" className="text-error" />

                                                        {AfflOrderConfirmFormik?.values?.changeMediumFlagProceedingsPdf &&
                                                            (
                                                                <button type='button' className="btn btn-primary" onClick={() => { viewImage(AfflOrderConfirmFormik?.values?.changeMediumFlagProceedingsPdf) }}>
                                                                    <FaEye size={20} />
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </td>
                                            </>) : (changeMediumFlagcolspanvalue)}
                                        </tr>
                                        <tr>

                                            <td className='text-left'>6.Change of Address of College:	 </td>
                                            <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="isChangeColgAddr"
                                                onChange={e => {
                                                    AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedings", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsDate", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsRefNo", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsPdf", '');
                                                }}>

                                                <option value=''>---selct---</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Field>
                                                <ErrorMessage name="isChangeColgAddr" component="div" className="text-error" />

                                            </td>
                                            {AfflOrderConfirmFormik?.values?.isChangeColgAddr == "true" ? (<>
                                                <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="isChangeColgAddrProceedings"
                                                    onChange={e => {
                                                        AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsDate", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsRefNo", '');
                                                        AfflOrderConfirmFormik?.setFieldValue("isChangeColgAddrProceedingsPdf", '');
                                                    }}>
                                                    <option value=''>---selct---</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Field>
                                                    <ErrorMessage name="isChangeColgAddrProceedings" component="div" className="text-error" />

                                                </td>
                                            </>) : (<td colSpan={4}></td>)}
                                            {AfflOrderConfirmFormik?.values?.isChangeColgAddr == "true" && AfflOrderConfirmFormik?.values?.isChangeColgAddrProceedings == "true" ? (<>

                                                <td >  <Field type="date" className="form-control" name="isChangeColgAddrProceedingsDate" onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="isChangeColgAddrProceedingsDate" component="div" className="text-error" />

                                                </td>
                                                <td><Field type="text" className="form-control" name="isChangeColgAddrProceedingsRefNo" maxLength="150" />
                                                    <ErrorMessage name="isChangeColgAddrProceedingsRefNo" component="div" className="text-error" /> </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <input type="file" name="isChangeColgAddrProceedingsPdf" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = `isChangeColgAddrProceedingsPdf`;
                                                                let path = "/Uploads/AffiliationPDFs/CDC/2023/";
                                                                ImagePdfBucket(e, AfflOrderConfirmFormik, path, `isChangeColgAddrProceedingsPdf`, filename, "pdf");
                                                            }}
                                                        />

                                                        <ErrorMessage name="isChangeColgAddrProceedingsPdf" component="div" className="text-error" />


                                                        {AfflOrderConfirmFormik?.values?.isChangeColgAddrProceedingsPdf &&
                                                            (
                                                                <button type='button' className="btn btn-primary" onClick={() => { viewImage(AfflOrderConfirmFormik?.values?.isChangeColgAddrProceedingsPdf) }}>
                                                                    <FaEye size={20} />
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </td>

                                            </>) : (isChangeColgAddrcolspanvalue)}

                                        </tr>
                                        <tr>

                                            <td className='text-left'>7. Has New Courses /Course Conversions / Additional Sections sanctioned by CHE/ University after the Date of issuance of Digital Affiliation Order by University</td>
                                            <td style={{ width: "1%" }}>  <Field as="select" className="form-control" name="permanentAfflStatusMeetingFlag"
                                                onChange={e => {
                                                    AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedings", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsDate", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsRefNo", '');
                                                    AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsPdf", '');
                                                }}>

                                                <option value=''>---selct---</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Field>
                                                <ErrorMessage name="permanentAfflStatusMeetingFlag" component="div" className="text-error" />

                                            </td>
                                            {AfflOrderConfirmFormik?.values?.permanentAfflStatusMeetingFlag === "true" ? (<>

                                                <td style={{ width: "1%" }}>
                                                    <Field as="select" className="form-control" name="permanentAfflStatusMeetingFlagProceedings"
                                                        onChange={e => {
                                                            AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsDate", '');
                                                            AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsRefNo", '');
                                                            AfflOrderConfirmFormik?.setFieldValue("permanentAfflStatusMeetingFlagProceedingsPdf", '');
                                                        }}>
                                                        <option value=''>---selct---</option>
                                                        <option value="true">Yes</option>
                                                        <option value="false">No</option>
                                                    </Field>
                                                    <ErrorMessage name="permanentAfflStatusMeetingFlagProceedings" component="div" className="text-error" />
                                                </td>
                                            </>) : (<><td colSpan={4}></td></>)}

                                            {AfflOrderConfirmFormik?.values?.permanentAfflStatusMeetingFlag === "true" && AfflOrderConfirmFormik?.values?.permanentAfflStatusMeetingFlagProceedings == "true" ? (<>
                                                <td>  <Field type="date" className="form-control" name="permanentAfflStatusMeetingFlagProceedingsDate" onKeyDown={(e) => { e.preventDefault() }} />
                                                    <ErrorMessage name="permanentAfflStatusMeetingFlagProceedingsDate" component="div" className="text-error" />

                                                </td>
                                                <td><Field type="text" className="form-control" name="permanentAfflStatusMeetingFlagProceedingsRefNo" maxLength="150" />
                                                    <ErrorMessage name="permanentAfflStatusMeetingFlagProceedingsRefNo" component="div" className="text-error" /> </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <input type="file" name="permanentAfflStatusMeetingFlagProceedingsPdf" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = `permanentAfflStatusMeetingFlagProceedingsPdf`;
                                                                let path = "/Uploads/AffiliationPDFs/CDC/2023/";
                                                                ImagePdfBucket(e, AfflOrderConfirmFormik, path, `permanentAfflStatusMeetingFlagProceedingsPdf`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name="permanentAfflStatusMeetingFlagProceedingsPdf" component="div" className="text-error" />

                                                        {AfflOrderConfirmFormik?.values?.permanentAfflStatusMeetingFlagProceedingsPdf &&
                                                            (
                                                                <button type='button' className="btn btn-primary" onClick={() => { viewImage(AfflOrderConfirmFormik?.values?.permanentAfflStatusMeetingFlagProceedingsPdf) }}>
                                                                    <FaEye size={20} />
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </td>


                                            </>) : (permanentAfflStatusMeeting20_21Flagcolspanvalues)}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">Any Other Proceedings issued with respect to this college:</h1></div>
                            <bie.Row className='px-3 my-3'>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                    <b style={{ color: 'red' }}>* </b>
                                    Any Other Proceedings issued with respect to this college
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>

                                    <Field as="select" className="form-control mb-2" name="otherPreceedings"
                                        onChange={(e) => {
                                            if (e.target.value == "true") {
                                                AfflOrderConfirmData?.proceedings?.forEach((pro, i) => {
                                                    AfflOrderConfirmFormik?.setFieldValue(`procedings[${i}].refNo`, pro?.ref_no);
                                                    AfflOrderConfirmFormik?.setFieldValue(`procedings[${i}].purposeOfIssuance`, pro?.purpose_of_issuance);
                                                    AfflOrderConfirmFormik?.setFieldValue(`procedings[${i}].otherProceedingsPdf`, pro?.other_proceedings_pdf);
                                                });
                                            }
                                            else {
                                                AfflOrderConfirmFormik.setFieldValue("procedings", [
                                                    {
                                                        refNo: "",
                                                        purposeOfIssuance: "",
                                                        otherProceedingsPdf: "",
                                                    }
                                                ]);
                                            }
                                        }}>
                                        <option value=''>---selct---</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </Field>
                                    <ErrorMessage name="otherPreceedings" component="div" className="text-error" />
                                </bie.Col>
                            </bie.Row>

                            {AfflOrderConfirmFormik?.values?.otherPreceedings === 'true' ? (<>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>SNO</th>
                                                <th>Reference Number of the Proceedings </th>
                                                <th>Purpose of the Issuance of the Proceedings  </th>
                                                <th>Upload Proceedings</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <FieldArray name="procedings">
                                                {(QualificationValues) => {
                                                    return QualificationValues?.form.values.procedings.map((qual, index) => {
                                                        return (
                                                            <>
                                                                <tr key={index}>
                                                                    <td>
                                                                        <center>{index + 1}</center>
                                                                    </td>
                                                                    <Field type="hidden" name={`procedings[${index}].slNo`} className="form-control" />
                                                                    <td >
                                                                        <Field type="text" name={`procedings[${index}].refNo`} className="form-control" maxLength="150" />
                                                                        <ErrorMessage name={`procedings[${index}].refNo`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td> <Field as="textarea" name={`procedings[${index}].purposeOfIssuance`} className="form-control" maxLength="500" />
                                                                        <ErrorMessage name={`procedings[${index}].purposeOfIssuance`} component="div" className="text-error" />
                                                                    </td>


                                                                    <td style={{ width: "15%" }}>
                                                                        <input type="file" className="form-control" name={`procedings[${index}].otherProceedingsPdf`} accept="application/pdf"
                                                                            onChange={(e) => {
                                                                                let fileVal = userId + "_" + acYear;
                                                                                let filename = fileVal + "otherProceedingsPdf"
                                                                                let path = "/Uploads/AffiliationPDFs/2023/CDC/Others_proceedings_pdfs/"
                                                                                ImagePdfBucket(e, AfflOrderConfirmFormik, path, `procedings[${index}].otherProceedingsPdf`, filename, "pdf")
                                                                            }} /> &nbsp;
                                                                        {AfflOrderConfirmFormik.values.procedings[index].otherProceedingsPdf && <button type='button' className="btn btn-primary"
                                                                            onClick={() => { viewImage(AfflOrderConfirmFormik.values.procedings[index].otherProceedingsPdf) }}><FaEye size={20} /></button>}

                                                                        <ErrorMessage name={`procedings[${index}].otherProceedingsPdf`} component="div" className="text-error" /></td>

                                                                    <td colSpan={2} align="center" className="col-md-1">
                                                                        {(index >= 1) ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-danger"
                                                                                onClick={() => QualificationValues.remove(index)} >
                                                                                <FaRegTrashAlt />
                                                                            </button>
                                                                        ) : <td></td>}

                                                                    </td>

                                                                </tr>
                                                            </>
                                                        );
                                                    });
                                                }}


                                            </FieldArray>

                                            <tr className='table-active'>
                                                <td colSpan={7} className='pe-3 text-end'>
                                                    <FieldArray name="procedings">
                                                        {(formikFieldArray) => {
                                                            return formikFieldArray.form.values.procedings.map((LJP, i) => {
                                                                return (<>
                                                                    {(i === 0) ? <> <button type="button" className="button-titile btn btn-sm btn-success me-4"
                                                                        onClick={() => {
                                                                            formikFieldArray.push({
                                                                                otherProceedingsPdf: "",
                                                                                refNo: "",
                                                                                purposeOfIssuance: "",
                                                                                slNo: ""

                                                                            });
                                                                        }}>
                                                                        <VscDiffAdded></VscDiffAdded>
                                                                    </button> </> : ''}
                                                                </>)
                                                            })
                                                        }}
                                                    </FieldArray>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {AfflOrderConfirmData?.proceedings && AfflOrderConfirmData?.proceedings.length > 0 ? (<>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive aafl-table">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Reference Number of the Proceedings</th>
                                                    <th>Purpose of the Issuance of the Proceedings</th>
                                                    <th>Upload Proceedings </th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {AfflOrderConfirmData?.proceedings && AfflOrderConfirmData?.proceedings?.map((afflorderdata, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td className='text-left'>{afflorderdata?.ref_no}</td>
                                                            <td className='text-left'>{afflorderdata?.purpose_of_issuance}</td>
                                                            <td className='cen'>
                                                                {afflorderdata?.other_proceedings_pdf && (
                                                                    <button
                                                                        type="button"
                                                                        className='btn btn-primary'
                                                                        onClick={() => {
                                                                            viewImage(afflorderdata?.other_proceedings_pdf);
                                                                        }} style={{ cursor: 'pointer' }} >
                                                                        <FaEye size={20} />
                                                                    </button>
                                                                )}

                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>) : (<></>)}
                            </>) : (<></>)}

                            {Type && Type === "NONOAMDC" ? (<>

                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0"> University Inspection Team Report Details
                                    </h1></div>

                                <bie.Row className='px-3 my-3'>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-3'>
                                        <label className='mb-1'>New Courses Deficiencies Remarks:</label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-3'>
                                        <b >{AfflOrderConfirmData?.totalData[0]?.any_def_4new_course}</b>

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-3'>
                                        <label className='mb-1'>Consolidated Deficiency Report:</label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-2'>

                                        <b >{AfflOrderConfirmData?.totalData[0]?.consolid_def_report}</b>
                                    </bie.Col>
                                </bie.Row>

                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1'>Consolidated Deficiency Report:</label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <b >{AfflOrderConfirmData?.totalData[0]?.recmnd_optn}</b>

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1'>Remarks by the Inspection Team:</label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <b >{AfflOrderConfirmData?.totalData[0]?.recmnd_optn}</b>

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-3'>
                                        <label className='mb-1'>Date of Inspection of the College:</label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-3'>
                                        <b >{AfflOrderConfirmData?.totalData[0]?.date_of_insp}</b>

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} tes txl={3} xxl={3} className='d-flex align-items-center pt-3'>
                                        <label className='mb-1'>FFCA Undertaking PDF:</label>
                                        <div className=""> {AfflOrderConfirmData?.totalData[0]?.upload_pdf && (
                                            <button type="button" className='btn btn-primary'
                                                onClick={() => {
                                                    viewImage(AfflOrderConfirmData?.totalData[0]?.upload_pdf);
                                                }}
                                            >
                                                <FaEye size={20} />
                                            </button>
                                        )}</div>
                                    </bie.Col>
                                    {/* </bie.Row>
                                    <bie.Row> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='d-flex align-items-center pt-3'>
                                        <label className='mb-1'>FFCA Proceedings PDF:</label>
                                        <div> {AfflOrderConfirmData?.totalData[0]?.proceeding_upload_university && (
                                            <button type='button' className=' btn btn-primary'
                                                onClick={() => {
                                                    viewImage(AfflOrderConfirmData?.totalData[0]?.proceeding_upload_university);
                                                }}
                                            >
                                                <FaEye size={20} />
                                            </button>
                                        )}</div>
                                    </bie.Col>
                                </bie.Row>
                            </>) : null}
                            <bie.Row >
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='pt-2'>
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>
                                        Has the Affiliation- Inspection Team Reported any Deficiencies?
                                    </label>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='pt-2'>
                                    <Field as="select" className="form-control mb-2" name="isDeficienciesYesNo"
                                        onChange={(e) => {
                                            if (e.target.value == "true") {
                                                AfflOrderConfirmData?.deficiencies?.forEach((def, i) => {
                                                    AfflOrderConfirmFormik?.setFieldValue(`deficiencies[${i}].lastDate`, def?.last_date);
                                                    AfflOrderConfirmFormik?.setFieldValue(`deficiencies[${i}].description`, def?.description);
                                                    AfflOrderConfirmFormik?.setFieldValue(`deficiencies[${i}].campusType`, def?.campus_type?.toString() ?? '');
                                                });
                                            }
                                            else {
                                                AfflOrderConfirmFormik.setFieldValue("deficiencies", [
                                                    {
                                                        lastDate: "",
                                                        description: "",
                                                        campusType: "",
                                                    }
                                                ]);
                                                AfflOrderConfirmFormik.setFieldValue("noDefiCertif", "")
                                            }
                                        }}>
                                        <option value="">---Select---</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                        <option value="notdone">Inspection Not Done</option>

                                    </Field>
                                    <ErrorMessage name="isDeficienciesYesNo" className='text-error' component="div" />
                                </bie.Col>
                            </bie.Row>


                            {/* && AfflOrderConfirmData?.deficiencies?.length === 0 */}
                            {AfflOrderConfirmFormik?.values?.isDeficienciesYesNo === 'true' ?
                                (<>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>SNO</th>
                                                    <th>Content of the deficiency </th>
                                                    <th>Last Date for Rectification  of Deficiencies	 </th>
                                                    <th>Campus Type</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <FieldArray name="deficiencies">
                                                    {(QualificationValues) => {
                                                        return QualificationValues.form.values.deficiencies.map((qual, index) => {
                                                            return (
                                                                <>
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <center>{index + 1}</center>
                                                                        </td>
                                                                        <td>
                                                                            <Field type="hidden" name={`deficiencies[${index}].slNo`} className="form-control" />
                                                                            <Field as="textarea" name={`deficiencies[${index}].description`} className="form-control" maxLength="1500" />
                                                                            <ErrorMessage name={`deficiencies[${index}].description`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td> <Field type="date" name={`deficiencies[${index}].lastDate`} className="form-control" onKeyDown={(e) => { e.preventDefault() }}
                                                                            min={new Date().toISOString().split('T')[0]} />
                                                                            <ErrorMessage name={`deficiencies[${index}].lastDate`} component="div" className="text-error" />
                                                                        </td>

                                                                        <td>
                                                                            <Field as="select" className="form-control" name={`deficiencies[${index}].campusType`}>
                                                                                <option value=''> ---select---</option>
                                                                                <option value='main'>Main Campus</option>
                                                                                <option value='off'>Off Campus</option>
                                                                            </Field>
                                                                            <ErrorMessage name={`deficiencies[${index}].campusType`} component="div" className="text-error" />
                                                                        </td>

                                                                        <td colSpan={2} align="center" className="col-md-1">
                                                                            {(index >= 1) ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="button-titile btn btn-sm btn-danger"
                                                                                    onClick={() => QualificationValues.remove(index)} >
                                                                                    <FaRegTrashAlt />
                                                                                </button>
                                                                            ) : <td></td>}

                                                                        </td>

                                                                    </tr>
                                                                </>
                                                            );
                                                        });
                                                    }}


                                                </FieldArray>

                                                <tr className='table-active'>
                                                    <td colSpan={7} className='pe-3 text-end'>
                                                        <FieldArray name="deficiencies">
                                                            {(formikFieldArray) => {
                                                                return formikFieldArray?.form?.values?.deficiencies.map((LJP, i) => {
                                                                    return (<>
                                                                        {(i === 0) ? <> <button type="button" className="button-titile btn btn-sm btn-success me-4"
                                                                            onClick={() => {
                                                                                formikFieldArray.push({
                                                                                    lastDate: "",
                                                                                    description: "",
                                                                                    campusType: "",
                                                                                    slNo: ""

                                                                                });
                                                                            }}>
                                                                            <VscDiffAdded></VscDiffAdded>
                                                                        </button> </> : ''}
                                                                    </>)
                                                                })
                                                            }}
                                                        </FieldArray>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {AfflOrderConfirmData?.deficiencies.length > 0 ? (<>
                                        <div className="inner-herbpage-service-title-sub">
                                            <h1 className="mb-0">List of Deficiencies</h1></div>
                                        <div className="table-responsive">

                                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Content of the deficiency	</th>
                                                        <th>Last Date for Rectification of Deficiencies		</th>
                                                        <th>Campus Type</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {AfflOrderConfirmData?.deficiencies && AfflOrderConfirmData?.deficiencies?.map((afflorderdata, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr>
                                                                <td>{index + 1}</td>
                                                                <td className='text-left'>{afflorderdata?.description || '-'}</td>
                                                                <td className='cen'>{afflorderdata?.last_date || '-'}</td>
                                                                <td>{afflorderdata?.campus_type || '-'}</td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>) : (<></>)}
                                </>) : (<></>)}
                            {AfflOrderConfirmFormik?.values?.isDeficienciesYesNo === 'false' ? (<>
                                <bie.Alert variant='danger'>
                                    <Field type='checkbox' name="noDefiCertif"
                                    /> &emsp;
                                    I hereby certify that college is running in accordance with the Affiliation norms of the University and there are no deficiencies that are identified and can be accorded Affiliation for this academic year {acYear}

                                    <ErrorMessage name="noDefiCertif" component="div" className="text-error" />
                                </bie.Alert></>) : (<></>)}


                            {Type && Type === "OAMDC" ? (<>

                                <div className="inner-herbpage-service-title-sub-sidemenu pt-4"><h1 className="m-0 p-0 pb-2">Recommendations of CDC dean to Registrar / VC</h1></div>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        <label className='mb-1'>Final Recommendations of CDC Dean :</label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} >
                                        <Field as='select' name="finalRecomondationCdcDean" className='form-control mb-2'>
                                            <option value=''> ---select---</option>
                                            <option value="Recommending for Withdrawal of Affiliation">Recommending for Withdrawal of Affiliation</option>
                                            <option value="Recommending for Temporary Affiliation Order">Recommending for Temporary Affiliation Order</option>
                                            <option value="Recommending for Conditional Affiliation Order">Recommending for Conditional Affiliation Order</option>
                                            <option value="Recommending for Provisional Affiliation">Recommending for Provisional Affiliation</option>
                                            <option value="Recommending for Permanent  Affiliation">Recommending for Permanent Affiliation</option>
                                        </Field>
                                        <ErrorMessage name="finalRecomondationCdcDean" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                            </>) : ''}

                            {/* <div className="button-cend pt-1 mb-3 ">
                                <button type="submit" className="btn btn-success mt-2 float-end mb-2" >
                                    Submit
                                </button>
                            </div> */}
                            <div className="button-cend pt-1 mb-3">

                                {status === undefined || status === '' || status === null || status === false ? (
                                    <button type="submit" className="btn btn-success  mt-2 float-end mb-2">
                                        Submit
                                    </button>

                                ) : (<button type="button" onClick={() => {
                                    setIsFirstTabSubmitted(true);
                                    onNext(Type);
                                }} className='float-end' style={{ color: "brown", fontSize: "20px", textDecoration: "underline" }}>

                                    <FaHandPointRight size={24} />       Go to Course Details Confirmation
                                </button>)}
                            </div>
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container >
        </>
    )
}
